<app-component-html-template [(relevantAnalysisTypes)]="relevantAnalysisTypes"
  [packagingComponent]="mainBody" [form]="form" [componentSubtypes]="componentSubtypes"
  [callerId]="callerId" [packagingUnitTypeId]="mainBody.packagingComponentSubtypeId" [isPreview]="isPreview"
  [isTracked]="isTracked" [isFormLocked]="isFormLocked" [historyVersions]="historyVersions"
  [spinnerActive]="spinnerActive" [canEditForm]="canEditForm" [isUserValidator]="isUserValidator"
  [isEditPermitted]="isEditPermitted" [imageSource]="imageSource" [isMainBody]="true"
  [componentTypeSelectionLabel]="'component.fields.ofMainBody' | transloco"
  (submitted)="onComponentSubmit($event)" [isInternallyTracked]="isInternallyTracked"
  [isDataExchangeSubRequest]="isDataExchangeSubRequest"
  [isInOngoingDataExchange]="isInOngoingDataExchange"
  [subRequestInfo]="subRequestInfo"
  (commentAdded)="onSubRequestCommentAdded($event)"
  (finishSubRequestClicked)="onFinishSubRequest($event)"
  (approveSubRequestClicked)="onApproveSubRequest()"
  (reopenSubRequestClicked)="onReopenSubRequest()"
  (createDataExchangeRequestClicked)="createDataExchangeRequest($event)"
  (historicVersionClicked)="loadHistoryVersions(mainBody.id)" (historicVersionChanged)="onHistoryVersionChange($event)"
  (versionRenamed)="changeMainBodyVersionName($event)">

  <h1 header>{{ 'component.mainBody' | transloco }}</h1>

  <div doc>
    <app-doc-upload-section [(areaDto)]="mainBody.docArea" [isEditable]="canEditForm">
    </app-doc-upload-section>
  </div>

  <div image>
    <app-image-upload [canEditForm]="canEditForm" [images]="mainBody.images" (filesEdited)="onFilesEdited()">
    </app-image-upload>
  </div>

  <div certificate>
    <app-certificate-upload [canEditForm]="canEditForm" [certificates]="mainBody.certificates" [certificateTypes]="allCertificateTypes" (filesEdited)="onFilesEdited()">
    </app-certificate-upload>
  </div>

  <div pdf>
    <app-pdf-upload [canEditForm]="canEditForm" [pdfs]="mainBody.documents" (filesEdited)="onFilesEdited()">
    </app-pdf-upload>
  </div>

</app-component-html-template>
